import List from "@/components/list";
import vue from "@/main";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const setLeaderUser = listeners["setLeaderUser"] || function () { };
  const deleteLeaderUser = listeners["deleteLeaderUser"] || function () { };
  const { isConvene = false, onlyLook = false } = props
  const posts = ['召集人', '组长']

  // 移除组员
  function removeGroupUser(item) {
    vue.$emit("removeGroupUser", item);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [];
    if (posts.includes(item.groupPostName)) {
      if (isConvene) {
        dealConf.push(
          [
            "icon-delete-group", "取消召集人", () => deleteLeaderUser(vo),
          ]
        )
      } else {
        dealConf.push(
          [
            "icon-leaderUser", "设为组长", () => setLeaderUser(vo)
          ]
        )
        
      }
    } else {
      dealConf.push(["icon-remove", "移除组员", () => removeGroupUser(item), ""])
      dealConf.push([
        "icon-leaderUser",
        `设为${isConvene ? '召集人' : '组长'}`,
        () => {
          setLeaderUser(vo);
        },
      ])
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  let AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "120"),
    tableBaseProps("组内职务", "groupPostName", "120"),
    tableBaseProps("工作单位", "deptName", "m150"),
    tableBaseProps("单位及职务", "unitPosition", "m150"),
    tableBaseProps("职务", "positionName", "m150"),
    tableBaseProps("职级", "positionLevelName", "m150"),
    tableBaseProps("性别", "sexName", "90"),
    tableBaseProps("出生年月", "birthday", "m150"),
    tableBaseProps("政治面貌", "politicsName", "m150"),
    tableBaseProps("学历", "educationName", "120"),
    {
      label: "操作",
      fixed: "right",
      minWidth: "120",
      render: (vo) => <Deal vo={vo} />,
    },
  ];

  if (onlyLook) {
    AccountTableConfig.shift();
    AccountTableConfig.pop();
  }

  return (
    <List
      {...args}
      empty-text="尚未添加任何组员，点击右上角【组员管理】可进行组员添加"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
